// @flow

// Vendor
import React from 'react';

// Types
type Props = {};

const Loading = ({  }: Props) => (
  <div className="loading-container">
    <div className="loading loading--circle-bounce">
      <div className="loading__ball" />
      <div className="loading__ball" />
      <div className="loading__ball" />
    </div>
  </div>
);

export default Loading;
